import { MessagesPanel } from '../../messaging/MessagesPanel';

/** Admin → Messages. Shell already gives us the padded container. */
export function MessagesPage() {
  return <MessagesPanel title="Messages" />;
}
